import {ChangeDetectorRef,Output,EventEmitter, Component, OnDestroy, OnInit,Input,OnChanges,ChangeDetectionStrategy,ApplicationRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService} from "../../../../node_modules/ng2-translate/src/translate.service";
import {CompanyService} from "../../services/company-service/company-service";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CategoryService} from "../../services/category/category.service";
import {IntakeFormVM} from "../../models/IntakeForm.model";
import {IntakeFieldVM} from "../../models/IntakeForm.model";
import {FileUploadComponent} from "../shared/file-upload/file-upload.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import * as moment from 'jalali-moment';

@Component({
  selector: 'rw-intake-field',
  template: require('./intake-field.component.html'),
  styles: [require('./intake-field.style.css')],
  providers: [CategoryService]

})

export class IntakeFieldComponent implements OnDestroy, OnInit,OnChanges {
  @Input() intakeField:IntakeFieldVM = new IntakeFieldVM();
 @Output() intakeFieldChange=new EventEmitter();
  private optionsHasloaded:boolean=false;
  public dateObject:any = "";

  constructor(private ref:ChangeDetectorRef,
              public route:ActivatedRoute,
              public router:Router,
              public translate:TranslateService,
              public dialog:MatDialog,
              private categoryService:CategoryService
  ) {

    //this.uploader = new FileUploader({
    //  url: URL,
    //  disableMultipart: true, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
    //  formatDataFunctionIsAsync: true,
    //  formatDataFunction: async (item) => {
    //
    //    return new Promise( (resolve, reject) => {
    //
    //      resolve({
    //        name: item._file.name,
    //        length: item._file.size,
    //        contentType: item._file.type,
    //        date: new Date()
    //      });
    //    });
    //  }
    //});



  }
  uploadFile(intakeField:IntakeFieldVM) {
   this.openFileUploadDialog(intakeField)
    //this.companyService.getCompanyfullWebSiteUrl().subscribe(companyurl=> {
    //  let serviceUrl = companyurl + '/#/book?id=' + this.serviceItemDetail.id;
    //  this.sharingService.copyToClipboard(serviceUrl);
    //});

  }
  public openFileUploadDialog(intakeField:IntakeFieldVM):void {
    let parent=this;
    let dialogRef = this.dialog.open(FileUploadComponent, {
      width: '400px',
      data: {textToCopy: intakeField.label}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.file_name)
      parent.intakeField.value="file:uploadroot/"+result.file_name;

    });
  }



  ngOnDestroy():void {
  }

  ngOnInit():void {


  }

  confirmIntakeField()
  {
    this.intakeFieldChange.emit(this.intakeField);
  }
  ngOnChanges(changes):void {

    let parent=this;
     if(changes && this.intakeField )
     {
       if(this.intakeField.fieldType == 'Dropdown' && this.intakeField.selectorDataTypeId  )
       {
         this.optionsHasloaded=true;
          this.categoryService.getSelectorDataByTypeId(this.intakeField.selectorDataTypeId).subscribe(function(opts){
            parent.intakeField.options=opts;

          });
       }
     }

  }

  selectedDateStrChanged(event) {
    if (event) {
      this.intakeField.value = event;
    }
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/intake-form/intake-field.component.ts